<h2 mat-dialog-title class="header-section">{{ title }}</h2>
<mat-dialog-content class="meeting-summary-modal">
  <div class="row row-gutters">
    <div class="col col-xs-6 col-sm-4 col-md-2">
      <div class="activity-data-label">{{ 'ACTIVITY.DATE' | translate }}</div>
      <div class="activity-data-value">{{ meetingDate | date: 'MMM d, h:mm a' }}</div>
    </div>
    <div class="col col-xs-6 col-sm-4 col-md-2">
      <div class="activity-data-label">{{ 'ACTIVITY.DURATION' | translate }}</div>
      <div class="activity-data-value">{{ duration }}</div>
    </div>
    <div class="col col-xs-6 col-sm-4 col-md-2">
      <div class="activity-data-label">{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.SALES_SCORE' | translate }}</div>
      <div class="activity-data-value">{{ salesScore }}</div>
    </div>
    <div class="col col-xs-6 col-sm-4 col-md-2">
      <div class="activity-data-label">{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.SENTIMENT_SCORE' | translate }}</div>
      <div class="activity-data-value">{{ sentimentScore }}</div>
    </div>
    <div class="col col-xs-6 col-sm-4 col-md-2">
      <div class="activity-data-label">{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.ASSOCIATIONS' | translate }}</div>
      <div class="activity-data-value">
        <crm-association-popover [hideDivider]="true"></crm-association-popover>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="section">
    <h3 class="summary-header">
      {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.SUMMARY_TITLE' | translate }}
      <mat-icon class="copy-icon" (click)="copyToClipboard(summary)">content_copy</mat-icon>
    </h3>

    <p>{{ summary }}</p>
  </div>

  <div class="section">
    <h3 class="takeaways-header">
      {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.KEY_TAKEAWAYS' | translate }}
      <mat-icon class="copy-icon" (click)="copyToClipboard(keyTakeaways)">content_copy</mat-icon>
    </h3>
    <ul>
      <li *ngFor="let takeaway of keyTakeaways">{{ takeaway }}</li>
    </ul>
  </div>

  <div class="section">
    <h3 class="takeaways-header">
      {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.ACTION_ITEMS' | translate }}
      <mat-icon class="copy-icon" (click)="copyToClipboard(actionItems)">content_copy</mat-icon>
    </h3>
    <ul>
      <li *ngFor="let item of actionItems">{{ item }}</li>
    </ul>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="actions-right">
  <div class="evaluation-hands">
    <button class="thumbs-up" mat-icon-button (click)="thumbsUp()" tabindex="-1">
      <mat-icon>thumb_up</mat-icon>
    </button>
    <button class="thumbs-down" mat-icon-button (click)="thumbsDown()" tabindex="-1">
      <mat-icon>thumb_down</mat-icon>
    </button>
  </div>
  <span class="action-buttons">
    <button mat-stroked-button *ngIf="transcriptUrl" (click)="downloadTranscript()">
      {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.DOWNLOAD_TRANSCRIPT' | translate }}
    </button>
    <button
      mat-dialog-close
      mat-flat-button
      color="primary"
      *ngIf="!!processedTranscriptID"
      tabindex="-1"
      [routerLink]="externalRoutePrefix() + '/meetings/meeting/' + processedTranscriptID"
    >
      {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.GO_TO_MEETING' | translate }}
    </button>
    <button mat-flat-button color="primary" *ngIf="hasRecording()" (click)="viewRecording()" tabindex="-1">
      {{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.VIEW_RECORDING' | translate }}
    </button>
  </span>
</mat-dialog-actions>

<a #downloadAnchor [hidden]="true"></a>
